var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7869 10.2022H1.31146M1.31146 10.2022L4.18031 7.46994M1.31146 10.2022L4.18031 12.9344M1.31146 3.37158H12.7869M12.7869 3.37158L9.91802 0.639343M12.7869 3.37158L9.91802 6.10382",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoTransfer);
export default __webpack_public_path__ + "static/media/DashboardTodoTransfer.70da79ee166a8ae0ac79d9ae126ea481.svg";
export { ForwardRef as ReactComponent };